export const validateName = (name) => {
  const errors = [];
  // Regex pattern to match names with English or Arabic letters, spaces, and hyphens, minimum length of 8 characters
  const nameRegex = /^[a-zA-Z\u0600-\u06FF\s-]{8,}$/;
  if (!nameRegex.test(name)) {
    errors.push(
      "تنسيق الاسم غير صالح. يجب أن يكون طول الاسم 8 على الأقل ويمكن أن يحتوي فقط على أحرف ومسافات."
    );
  }

  return errors;
};
